'use strict';
import * as $j_app$002edata$002e$002dAccepted$002dRequest$002dProvided$002dE$002dP$002dS$002dCode$0024$002dProvided from "./app.data.-Accepted-Request-Provided-E-P-S-Code$-Provided.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31() {
}
export { $c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31 as $c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31 };
$c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31.prototype.constructor = $c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31;
/** @constructor */
function $h_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31() {
}
export { $h_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31 as $h_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31 };
$h_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31.prototype = $c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31.prototype;
$c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31.prototype.compose__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__compose__F1__F1(this, g);
});
$c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31.prototype.andThen__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__andThen__F1__F1(this, g);
});
$c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31.prototype.apply__Lapp_data_AcceptedRequestProvidedEPSCode__Z = (function(a) {
  return ((a instanceof $j_app$002edata$002e$002dAccepted$002dRequest$002dProvided$002dE$002dP$002dS$002dCode$0024$002dProvided.$c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided) && (a !== null));
});
$c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31.prototype.apply__O__O = (function(v1) {
  return this.apply__Lapp_data_AcceptedRequestProvidedEPSCode__Z(v1);
});
$c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return this.apply__Lapp_data_AcceptedRequestProvidedEPSCode__Z(v1);
});
var $d_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31, "app.data.AcceptedRequestProvidedEPSCode$$anon$31", ({
  Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31: 1,
  F1: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction1: 1
}));
export { $d_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31 as $d_Lapp_data_AcceptedRequestProvidedEPSCode$$anon$31 };
//# sourceMappingURL=app.data.-Accepted-Request-Provided-E-P-S-Code$$anon$31.js.map
